import { chain } from 'lodash'

// NOTE: セット(60分) x 3 とかやらなきゃなので（CourseHistories.vueから移設）
export const groupCourseHistories = (vendingHistories, hhmm) => {
  return chain(vendingHistories)
    .filter(vendingHistory => vendingHistory.attributes.vendibleType === 'Course')
    .orderBy(['attributes.persistenceReport.data.attributes.startAt'], ['desc'])
    .groupBy(courseHistory => {
      const { vendibleId, vendibleName } = courseHistory.attributes
      const { startAt, releaseAt } = courseHistory.attributes.persistenceReport.data?.attributes || {}
      if (!(startAt && releaseAt)) return null

      return `${vendibleId}${vendibleName}${hhmm(startAt)}${hhmm(releaseAt)}`
    })
    .mapValues((courseHistoriesGrouped, key) => {
      const { vendibleId, vendibleName } = courseHistoriesGrouped[0]?.attributes
      const { startAt, releaseAt } = courseHistoriesGrouped[0]?.attributes?.persistenceReport?.data?.attributes || {}

      return {
        key,
        vendibleId,
        vendibleName,
        startAt,
        releaseAt,
        size: courseHistoriesGrouped.length,
        actualData: courseHistoriesGrouped,
      }
    })
    .values()
    .value()
}

export const totalStayMinutes = (startAt, releaseAt) => {
  if (!(startAt && releaseAt)) return null

  // NOTE: 入店時刻には秒が乗る一方で編集後の終了時刻は分精度のため、
  // 表示時刻（HH:mm）と一致するよう双方を分精度に切り捨ててから差分を取る
  const minuteFloor = at => Math.floor(Date.parse(at) / 60000)

  return minuteFloor(releaseAt) - minuteFloor(startAt)
}

// NOTE: グループ（新しい順）を「1セット目 / 延長1..N」のセグメントにする
export const buildSessionSegments = groups => {
  const timedGroups = groups.filter(group => group.startAt && group.releaseAt)

  return timedGroups.map((group, index) => {
    // NOTE: 新しい順なので末尾が1セット目
    const isFirstSet = index === timedGroups.length - 1
    const extensionNumber = timedGroups.length - 1 - index
    const unitPrice = Number(group.actualData[0]?.attributes?.sellingPrice) || 0

    return {
      ...group,
      kind: isFirstSet ? 'set' : 'extension',
      label: isFirstSet ? '1セット目' : `延長 ${extensionNumber}`,
      autoCreated: group.actualData.some(vendingHistory => vendingHistory.attributes?.autoCreated === true),
      unitPrice,
      subtotal: group.actualData.reduce((acc, vendingHistory) => acc + (Number(vendingHistory.attributes?.sellingPrice) || 0), 0),
      durationMinutes: totalStayMinutes(group.startAt, group.releaseAt),
    }
  })
}

export const isExtending = segments => {
  return segments.some(segment => segment.kind === 'extension')
}

// NOTE: 取り消せるのは最新の延長のみ
export const cancellableSegment = segments => {
  const newest = segments[0]
  if (!newest || newest.kind !== 'extension') return null

  return newest
}

export const buildDestroyPayload = segment => {
  return segment.actualData.map(vendingHistory => ({
    id: vendingHistory.id,
    _destroy: true,
  }))
}

export default () => {
  return {
    groupCourseHistories,
    buildSessionSegments,
    isExtending,
    totalStayMinutes,
    cancellableSegment,
    buildDestroyPayload,
  }
}
